export const QUOTE_STATUSES = {
  PENDING: 'pending_approval',
  APPROVED: 'approved',
  CANCELED: 'canceled',
};

export const YOUSIGN = {
  EVENT_ORIGIN: 'https://yousign.app',
  EVENT_TYPE: 'yousign',
};
